"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarDividerStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdivider = require("@fluentui/react-divider");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "ftuwxu6",
        B2u0y6b: "f1lwjmbk",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "f11qrl6u",
            "fjlbh76"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "fjlbh76",
            "f11qrl6u"
        ]
    },
    vertical: {
        B2u0y6b: "fe668z"
    }
}, {
    d: [
        ".ftuwxu6{display:inline-flex;}",
        ".f1lwjmbk{max-width:1px;}",
        ".f1g0x7ka{padding-top:0;}",
        ".f11qrl6u{padding-right:12px;}",
        ".fjlbh76{padding-left:12px;}",
        ".f1qch9an{padding-bottom:0;}",
        ".fe668z{max-width:initial;}"
    ]
});
const useToolbarDividerStyles_unstable = (state)=>{
    (0, _reactdivider.useDividerStyles_unstable)(state);
    const { vertical } = state;
    const toolbarDividerStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(toolbarDividerStyles.root, !vertical && toolbarDividerStyles.vertical, state.root.className);
    return state;
}; //# sourceMappingURL=useToolbarDividerStyles.styles.js.map
